/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Calendar } from 'primereact/calendar';
import moment from "moment";

const CalendarBox = ({ name, label, value, onChange, lg, md, sm, esHora, requerido, minDate, maxDate, disabled }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    const change = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setSelectedValue(e.target.value);
        onChange(value, name);
    }

    useEffect(() => {
        if (!esHora) {
            if (value !== selectedValue) {
                setSelectedValue(value === null ? value : moment(value).toDate())
            }
        }
    }, [value]);

    return (
        <div className={`form-group col-lg-${lg} col-md-${md} col-sm-${sm} mt-2`}>
            <div className="form-group d-flex flex-column">
                <label htmlFor={name} className='etiquetas'>
                    {requerido &&
                        <span style={{ color: 'red' }}>* </span>
                    }
                    {label}
                </label>
                {esHora ?
                    <Calendar id={name} name={name} value={value} onChange={change} timeOnly hourFormat="12"
                        className={requerido && ((value ?? null) === null) ? 'p-invalid block' : ''} />
                    :
                    <Calendar id={name} name={name} value={selectedValue} onChange={change} dateFormat="dd/M/yy" disabled={disabled} locale={'es'}
                        yearRange="1950:2100"
                        className={requerido && ((value ?? null) === null) ? 'p-invalid block' : ''} minDate={minDate} maxDate={maxDate} />
                }
            </div>
        </div>
    );
};

export default CalendarBox;